import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { WebUIThemeProvider } from 'web-ui-components/lib/utilities/themes';
import App from './containers/App';

import { store } from './redux/store';
import {
  setQueryParams,
  fetchConfig,
  fetchContent,
  inValidParams
} from './redux/actions/configAction';
import { queryParser } from './utils/queryParseUtil';
import { isValidParameter } from './utils/validateParamUtil';
import { applyFaviconBasedOnBankId, removeHashUrl } from './utils/genericUtil';

const initialiseApp = async () => {
  const parsedParams = queryParser();
  let { brandId, accessToken } = parsedParams;
  const defaultBranding = () => import('web-ui-components/lib/app.vm.css');
  const applyBranding = () =>
    brandId === 'CB'
      ? import('web-ui-components/lib/app.cb.css')
      : brandId === 'VM'
      ? import('web-ui-components/lib/app.vm.css')
      : import('web-ui-components/lib/app.yb.css');
  brandId === 'B' ? defaultBranding() : applyBranding();
  applyFaviconBasedOnBankId('VM');

  if (!window.appLoaded) {
    await store.dispatch(setQueryParams(parsedParams));
    await store.dispatch(fetchConfig());
    window.appLoaded = true;
  }
  removeHashUrl();
  return {
    brandId,
    accessToken,
    parsedParams,
    state: store.getState()
  };
};

const startApp = async () => {
  let data = {};

  data = await initialiseApp();
  await renderApp(data);
};

const renderApp = async data => {
  const { brandId, accessToken, caseId } = await data;

  ReactDOM.render(
    <Provider store={store}>
      <WebUIThemeProvider brandID={brandId}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </WebUIThemeProvider>
    </Provider>,
    document.getElementById('root')
  );
};

startApp();
